import { FC } from 'react'

import { getSafeHtml } from '../../utils/sanitizeUtils'

import * as SC from './styled'

export type PushMessageProps = {
  className?: string
  text: string
  onClose?: () => void
}

const PushMessage: FC<PushMessageProps> = (props) => {
  const { className, text, onClose } = props

  return (
    <SC.Container className={className}>
      <SC.Text dangerouslySetInnerHTML={getSafeHtml(text)} />
      <SC.CloseButtonWrapper onClick={onClose}>
        <SC.CloseButton icon="close" />
      </SC.CloseButtonWrapper>
    </SC.Container>
  )
}

export default PushMessage
